import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export const ZeroPercent = ({ width = 27, height = 13, fill = '#119B94', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 27 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9438 7.08163C12.9377 7.08163 11.8574 5.62415 11.8574 3.54939C11.8574 1.45748 12.9891 0 14.9438 0C16.9843 0 18.0646 1.45748 18.0817 3.54939C18.0646 5.65845 16.9672 7.08163 14.9438 7.08163ZM14.9438 5.24692C15.6469 5.24692 15.9898 4.5782 15.9898 3.54939C15.9898 2.53773 15.664 1.83471 14.9438 1.83471C14.2923 1.83471 13.9493 2.57202 13.9493 3.54939C13.9493 4.5782 14.3266 5.24692 14.9438 5.24692ZM23.8773 12.7501C21.8712 12.7501 20.7909 11.2926 20.7909 9.21783C20.7909 7.12592 21.9226 5.66844 23.8773 5.66844C25.9178 5.66844 26.9981 7.12592 26.9981 9.21783C26.9981 11.3269 25.8835 12.7501 23.8773 12.7501ZM23.8773 10.9154C24.5632 10.9154 24.9061 10.2466 24.9233 9.21783C24.9061 8.20617 24.5975 7.50315 23.8773 7.52029C23.2258 7.50315 22.8657 8.24046 22.8657 9.21783C22.8657 10.2466 23.2429 10.9154 23.8773 10.9154ZM14.0008 12.5908L22.5399 0.176463H24.8204L16.2813 12.5908H14.0008Z"
        fill={fill}
      />
      <path
        d="M4.98972 12.7621C1.88615 12.7621 0 10.4473 0 6.3835C0 2.3197 1.88615 0.00488281 4.98972 0.00488281C8.0933 0.00488281 9.97944 2.33685 9.97944 6.3835C9.97944 10.4644 8.0933 12.7621 4.98972 12.7621ZM4.98972 10.6359C6.43005 10.6359 7.35598 9.24701 7.33884 6.3835C7.33884 3.55427 6.43005 2.11394 4.98972 2.11394C3.54939 2.11394 2.64061 3.55427 2.64061 6.3835C2.62346 9.24701 3.54939 10.6359 4.98972 10.6359Z"
        fill={fill}
      />
    </Svg>
  );
};

export default ZeroPercent;
